(() => {
  const key = 'franztels-under-construction-origin';
  const current = new URL(location.href);
  const back = document.querySelector('.franztels-under-construction-back');
  const safe = (value) => {
    if (!value) return null;
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || url.href === current.href) return null;
      if (url.pathname === '/pages/under-construction' && url.searchParams.get('view') !== 'pet-parlor') return null;
      return url.href;
    } catch { return null; }
  };
  if (back) {
    let saved;
    try {
      saved = sessionStorage.getItem(key);
      sessionStorage.removeItem(key);
    } catch {}
    const destination = safe(saved) || safe(history.state?.franztelsReturnTo) || safe(document.referrer);
    if (destination) {
      back.href = destination;
      try { history.replaceState({ ...history.state, franztelsReturnTo: destination }, '', location.href); } catch {}
    }
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || back || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try {
      const target = new URL(link.href, location.origin);
      if (target.origin === location.origin && target.pathname === '/pages/under-construction' && !target.searchParams.get('view')) {
        sessionStorage.setItem(key, current.href);
      }
    } catch {}
  }, true);
})();
